import React from "react";

class Spinner extends React.Component {
	render() {
		return <div className={"gs-fb-spinner"}>
				<div/>
				<div/>
				<div/>
		</div>
	}
}

export default Spinner